import { render, staticRenderFns } from "./DbSwitchConfirmModal.vue?vue&type=template&id=aa192376"
import script from "./DbSwitchConfirmModal.vue?vue&type=script&lang=js"
export * from "./DbSwitchConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports